<script setup>
import {ref} from "vue";
import Swal from "sweetalert2";

const showCopyConfirmation = ref(false);

const props = defineProps({
  text: {
    type: [String, Number],
    required: true,
  },
});
const copy = async () => {
  try {
    await window.navigator.clipboard.writeText(props.text)
    showCopyConfirmation.value = true;
    setTimeout(() => showCopyConfirmation.value = false, 1500)
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'We couln\'t copy the text!' ,
      html: 'We\'re unable to write to your clipboard, please copy the text manually.',
    })
  }
};
</script>

<template>
  <div
    id="copy-box-container"
    class="tw-flex"
  >
    <div class="tw-self-center">
      <div
        v-if="showCopyConfirmation"
        v-tooltip="{
          content: 'Copied',
          shown: showCopyConfirmation,
          triggers: [],
        }"
      />
      <div v-tooltip="'Copy to clipboard'">
        <SvgVue
          class="tw-h-4 tw-w-4 tw-cursor-pointer"
          icon="icons/copy"
          @click="copy"
        />
      </div>
    </div>
  </div>
</template>
